<template>
  <div id="app">
    <div class="main-wrapper container-fluid">
      <div class="navbar-bg"></div>
      <b-navbar
        toggleable="lg"
        type="dark"
        variant="primary"
        class="navbar navbar-expand-lg main-nav"
      >
        <b-navbar-brand href="#">JUNOMARKETS</b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
             <Notification />
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <em>{{ getName }} - ({{ role }})</em>
              </template>
              <b-dropdown-item href="#" class="danger" @click="logout">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <nav class="navbar navbar-secondary navbar-expand-lg">
        <div class="container">
          <ul class="navbar-nav">
            <b-nav-item to="/exposure">
              <i class="far fa-heart"></i>
              <span>Exposure</span>
            </b-nav-item>

            <!-- <b-nav-item to="/exposure-test">
              <i class="far fa-heart"></i>
              <span>Exposure Test</span>
            </b-nav-item> -->

             <b-nav-item to="/focus" v-if="role == 'admin'">
              <i class="far fa-heart"></i>
              <span>Focus</span>
            </b-nav-item>

             <b-nav-item to="/position" v-if="role == 'admin'">
              <i class="far fa-heart"></i>
              <span>Position</span>
            </b-nav-item>

            <b-nav-item to="/suppressions" v-if="role == 'admin'">
              <i class="far fa-heart"></i>
              <span>Suppression</span>
            </b-nav-item>

             <b-nav-item to="/contest" v-if="role == 'admin'">
              <i class="far fa-heart"></i>
              <span>Contest Management</span>
            </b-nav-item>

             <b-nav-item to="/settings/users" v-if="role == 'admin'">
              <i class="far fa-user"></i>
              <span>User Management</span>
            </b-nav-item>
          </ul>
        </div>
      </nav>

      <!-- Main Content -->
      <router-view />
      <footer class="main-footer">
        <div class="footer-left">
          Copyright &copy; 2020
          <div class="bullet"></div>junomarkets
        </div>
        <div class="footer-right"></div>
      </footer>
    </div>
  </div>
</template>

<script>
import Topbar from './Topbar.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import Notification from '@/components/utils/Notification'

export default {
  components: {
    Topbar, Notification
  },
  data() {
    return {
      toggled: false,
      toggleProfile: false
    }
  },
  computed: {
    ...mapGetters(['role']),
    getName()
    {
      return this.$store.state.user.name
    }
  },
  methods: {
    toggleAction() {
      this.toggleProfile = !this.toggleProfile
    },
    logout() {
      this.$store.dispatch("user/logout").then(() => {
        this.$router.push("/login")
      }).catch(() => console.error("error"))
    }
  }
}
</script>
